import React from "react";
import { makeStyles, Typography } from "e100-react-components";
import { ProgressBar, ProgressBarProps } from "./ProgressBar";

const useStyles = makeStyles(({ spacing, palette }) => ({
  container: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
}));

interface CircularProgressBarProps extends ProgressBarProps {
  message?: string;
}

export const CircularProgressBar = ({ icon, completedPercent, message }: CircularProgressBarProps) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <ProgressBar icon={icon} completedPercent={completedPercent} />

      {message && (
        <Typography variant="body2" color="secondary">
          {message}
        </Typography>
      )}
    </div>
  );
};
